module.exports = __webpack_public_path__ + "static/media/kudos_ic.9f28d0a3.svg";